import React from 'react'

import { makeStyles } from '@material-ui/core'
import type { Theme } from '@material-ui/core'

import { Button } from '@paintscout/ui'
import CoreSignatureCanvas from './CoreSignatureCanvas'
import type { CoreSignatureCanvasProps } from './CoreSignatureCanvas'

export interface SignatureCanvasProps extends Omit<CoreSignatureCanvasProps, 'Button'> {}

const useStyles = makeStyles<Theme, SignatureCanvasProps>((theme) => ({
  canvas: {
    border: `dashed ${theme.typography.pxToRem(2)} ${theme.paintscout.palette.brand.Neutral.P85}`
  },
  captionRow: {
    paddingTop: theme.typography.pxToRem(15),
    paddingBottom: theme.typography.pxToRem(10)
  },
  caption: {
    ...theme.typography.button,
    color: theme.paintscout.palette.brand.Neutral.P75
  }
}))

function SignatureCanvas(props: SignatureCanvasProps) {
  const classes = useStyles(props)
  return <CoreSignatureCanvas Button={Button} {...props} classes={classes} />
}

export default SignatureCanvas
